import { gql } from "apollo-boost"

export const CREATE_SHEDULE_PLACE = gql`
  mutation Mutation($schedulePlaceData: CreateSchedulePlaceInput!) {
  CreateSchedulePlace(schedulePlaceData: $schedulePlaceData) {
    lat
    lnt
  }
}
`